import {
  FETCH_PENDING_DRIVER_REG_COUNT_SUCCESS,
  UPDATE_PENDING_DRIVER_REG_COUNT,
} from '../actions/pendingDriverRegistration';

const initialState = {
  pendingCount: 0,
  registeredCount: 0,
};

export default function pendingDriverRegistrationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PENDING_DRIVER_REG_COUNT_SUCCESS:
    case UPDATE_PENDING_DRIVER_REG_COUNT:
      return {
        ...state,
        pendingCount: Number(action.payload?.pendingCount) || 0,
        registeredCount: Number(action.payload?.registeredCount) || 0,
      };
    default:
      return state;
  }
}
